<template lang="pug">
InheritWrapper(v-model="inherit" :readonly="innerSetting.ReadOnly || disabled")
  BriqTimeInput(
      :label="innerSetting.DisplayName"
      name="timeInput"
      :disabled="innerSetting.ReadOnly || disabled ? true : inherit"
      :hide-clear-button="true"
      :error="fieldError"
      :required="this.$attrs.required"
      v-model="innerValue"
      place-holder="--:--"
      :twelve-hour-clock="isTwelveHourClock"
  )
</template>

<script>
import InheritWrapper from '@v/settings/application/advanced/InheritWrapper.vue'
import setupInheritedField from './setupInheritedField.js'
import BriqTimeInput from '@/vue/components-global/BriqTimeInput.vue'
import { toRefs, computed } from '@vue/composition-api'
import mixin from '@v/settings/application/advanced/mixin.js'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Time',
  components: { InheritWrapper, BriqTimeInput },
  mixins: [mixin],
  props: {
    setting: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      isTwelveHourClock: this.$twelvehourclock,
    }
  },
  validations() {
    return {
      innerValue: {
        required,
        $each: {
          required,
        },
      },
    }
  },
  setup: (props, { emit }) => {
    const fields = setupInheritedField({ props, emit })
    return {
      ...toRefs(fields),
      type: computed(() => (props.setting.DataType === 'String' ? 'text' : 'number')),
      step: computed(() => (props.setting.DataType === 'Decimal' ? '0.01' : '1')),
    }
  },
}
</script>
